/**
 * If the new marketplace requires its own theme and ui style then also need to check:
 *   - uiService.getThemeClassList
 *   - themeServices.getThemeInstance
 *   - themeVariables
 *   - scss file in styles/themes
 */

const marketPlaces = {
    cambridge_innovation: 'cambridge_innovation',
    cambridge: 'cambridge',
    ceq: 'ceq',
    cxc: 'cxc',
    fjord: 'fjord',
};

export default marketPlaces;
